import IssuesService from 'src/modules/issues/issuesService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'ISSUES_VIEW';

const issuesViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: issuesViewActions.FIND_STARTED,
      });

      const record = await IssuesService.find(id);

      dispatch({
        type: issuesViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesViewActions.FIND_ERROR,
      });

      getHistory().push('/issues');
    }
  },
};

export default issuesViewActions;
